import { queryOptions } from "@tanstack/react-query";
import { $getImportBatches } from "./functions";

export const importBatchesQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ["imports", "batches", projectId],
    queryFn: ({ signal }) => $getImportBatches({ signal, data: { projectId } }),
  });
